import { apiRequest } from "../http";
import { IResponse } from "../../types/response.type";
import type {
	GetBumblebeeMessagesSuccessData,
	ListBumblebeeSessionsSuccessData,
	MarkBumblebeeSessionReadSuccessData,
	UpdateBumblebeeTitleSuccessData,
} from "../../types/bumblebee.type";

export type IListBumblebeeSessionsResponse =
	IResponse<ListBumblebeeSessionsSuccessData>;
export type IGetBumblebeeMessagesResponse =
	IResponse<GetBumblebeeMessagesSuccessData>;
export type IUpdateBumblebeeTitleResponse =
	IResponse<UpdateBumblebeeTitleSuccessData>;
export type IMarkBumblebeeSessionReadResponse =
	IResponse<MarkBumblebeeSessionReadSuccessData>;

export async function listBumblebeeSessions(): Promise<IListBumblebeeSessionsResponse> {
	return await apiRequest<ListBumblebeeSessionsSuccessData>({
		path: "/api/bumblebee/sessions",
		method: "GET",
	});
}

export async function getBumblebeeMessages(
	session_id: string,
): Promise<IGetBumblebeeMessagesResponse> {
	return await apiRequest<GetBumblebeeMessagesSuccessData>({
		path: `/api/bumblebee/sessions/${encodeURIComponent(session_id)}/messages`,
		method: "GET",
	});
}

export async function updateBumblebeeSessionTitle(params: {
	session_id: string;
	body: { title: string };
}): Promise<IUpdateBumblebeeTitleResponse> {
	return await apiRequest<UpdateBumblebeeTitleSuccessData>({
		path: `/api/bumblebee/sessions/${encodeURIComponent(params.session_id)}/title`,
		method: "PATCH",
		json: params.body,
	});
}

export async function markBumblebeeSessionRead(
	session_id: string,
): Promise<IMarkBumblebeeSessionReadResponse> {
	return await apiRequest<MarkBumblebeeSessionReadSuccessData>({
		path: `/api/bumblebee/sessions/${encodeURIComponent(session_id)}/read`,
		method: "POST",
	});
}
